import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { API_MANAGEMENT_TABS } from '@pages/api-portal/constants';

/*
 * Tab state for the API Management shell — URL-driven via ?tab= so external links can
 * deep-link to a specific tab.
 */
export function useApiManagement() {
    const history = useHistory();
    const location = useLocation();

    const activeTab = new URLSearchParams(location.search).get('tab') ?? API_MANAGEMENT_TABS.groups;

    /*
     * Updates the active tab and syncs it to the URL as ?tab=<value>.
     */
    const setActiveTab = useCallback(
        (tab: string) => {
            const params = new URLSearchParams(location.search);
            params.set('tab', tab);
            history.replace(`${location.pathname}?${params.toString()}`);
        },
        [history, location.pathname, location.search],
    );

    return { activeTab, setActiveTab };
}
